/**
 * Andre Garen - Stil senkron motoru (site-geneli).
 *
 * Denetim (CX Faz 2): Faz 1'de bu mantik SADECE ag-wardrobe.js icindeydi -
 * ama favoriler (kalp ikonu) urun kartlarinda ve urun sayfasinda HER YERDE
 * tetiklenebiliyor, sadece Gardirobum sayfasinda degil. Bu yuzden sync
 * motoru buraya, site-geneli/kosulsuz yuklenen bir script'e tasindi.
 * ag-wardrobe.js artik kendi kopyasini tutmuyor, bunun yerine
 * window.AGStilSync'i kullaniyor (bkz. ag-wardrobe.js reconcileWithServer).
 *
 * Veri > localStorage > sunucu oncelik sirasi (Faz 1'deki olculer ile ayni):
 * giris yapmis musteride sunucu (customer.metafields.stil.*) her zaman
 * localStorage'dan ustun sayilir - localStorage yalnizca sunucu bossa ya da
 * daha eskiyse devreye girer (bkz. ag-wardrobe.js icindeki reconcileWithServer,
 * quiz/olcu/favoriler/anlar icin ayni mantik).
 *
 * Denetim (Faz 3): eski ag:styleType/ag:quizRaw ciftinin yerini tek bir
 * ag:profil aldi - yeni quiz artik stil.quiz/stil.tip DEGIL, stil.profil
 * (JSON, bkz. ag-wardrobe.js freshProfil) uretiyor. Eski iki anahtar artik
 * hic yazilmiyor/okunmuyor (localStorage'da kalmis olsalar bile zararsiz).
 */
(function () {
  'use strict';

  var SYNC_ENDPOINT_SAVE = '/apps/stil/save';
  var SYNC_KEYS = ['ag:measurements', 'ag:profil', 'ag:favorites', 'ag:moments', 'ag:sezonPlani'];
  var loggedIn = document.body.getAttribute('data-ag-logged-in') === '1';
  var syncTimer = null;
  var syncPending = false; /* Tur 9 T9-009: debounce'ta bekleyen (henuz gonderilmemis) degisiklik var mi */

  /* Tur 9 T9-008: stil verisi (SYNC_KEYS + ag:stilUpdatedAt) cihazdaki HESABA baglanir. body
     data-ag-cid = giris yapmis musterinin id'si (misafirde bos). ag:owner BASKA bir hesabi gosteriyorsa
     (ayni cihazda baska hesapla giris ya da cikis yapilmis) veri silinir - misafir onceki kullanicinin
     olculerini/favorilerini gormez, B hesabina A'nin verisi yazilmaz. Misafirken doldurulan veri
     (owner 'guest') giriste KORUNUR ve mevcut akisla hesaba tasinir. Eski cihazlarda ag:owner yoksa
     hicbir sey silinmez (yalniz sahip yazilir). */
  (function bindOwner() {
    try {
      var cid = document.body.getAttribute('data-ag-cid') || '';
      if (loggedIn && !cid) return; /* savunma: kimlik okunamiyorsa hicbir sey silme */
      var me = loggedIn ? 'c:' + cid : 'guest';
      var owner = localStorage.getItem('ag:owner');
      if (owner && owner !== me && owner !== 'guest') {
        SYNC_KEYS.concat(['ag:stilUpdatedAt']).forEach(function (k) { localStorage.removeItem(k); });
      }
      localStorage.setItem('ag:owner', me);
    } catch (e) {}
  })();
  var suppressSync = false;

  var LS = {
    get: function (k, fallback) {
      try {
        var v = localStorage.getItem(k);
        return v ? JSON.parse(v) : fallback;
      } catch (e) {
        return fallback;
      }
    },
    set: function (k, v) {
      try {
        localStorage.setItem(k, JSON.stringify(v));
      } catch (e) {}
      if (!suppressSync && loggedIn && SYNC_KEYS.indexOf(k) !== -1) scheduleSync();
    }
  };

  function buildSyncPayload() {
    var measurements = LS.get('ag:measurements', null);
    var profil = LS.get('ag:profil', null);
    var favorites = LS.get('ag:favorites', null);
    var moments = LS.get('ag:moments', null);
    var payload = {};
    if (measurements) payload.olculer = measurements;
    if (profil) payload.profil = profil;
    /* Tur 9 T9-010: bos dizi de gonderilir (= son favori kaldirildi) - anlardaki Faz 4A dersiyle ayni:
       "bos liste gonder" (temizle) ile "hic gonderme" (dokunma) farkli. null (hic kullanilmamis) gitmez. */
    if (favorites) payload.favoriler = favorites;
    /* Faz 4A: yaklasan_anlar artik {version:2, items:[...]} objesi - eski
       duz-dizi varsayimi (moments.length) v2 objede her zaman undefined
       donup alanin hic gonderilmemesine yol acardi (Worker'a hicbir zaman
       yeni moment ulasmazdi).

       Denetim (gercek hesap testi, Cowork): burada items.length kontrolu
       YOKTUR ve olmamali. Worker'in kurali "payload'da olmayan alana
       dokunma" (bkz. handleSave `'yaklasan_anlar' in body`) - bu yuzden
       "bos liste gonder" (= temizle) ile "hic gonderme" (= degistirme)
       tamamen farkli anlamlara geliyor. Son kalan moment silinip items
       bosaldiginda alan yine gonderilmeli, yoksa silme sunucuya hic
       yansimaz ve sayfa yenilenince moment geri gelir. moments null ise
       (moment sistemi hic kullanilmamis) ustteki kontrol yine atlar. */
    if (moments && moments.items) payload.yaklasan_anlar = moments;
    /* Faz 4B: sezon_plani UC durumlu - LS.get anahtar hic yoksa undefined
       (=> payload'a girmez, Worker alana DOKUNMAZ), localStorage'da "null"
       yaziyorsa null (=> Worker metafield'i SILER, "Plani sil"), obje varsa
       obje (=> dogrula ve yaz). Doluluk kontrolu (items.length tarzi) YOK -
       bkz. yukaridaki Faz 4A dersi, ayni tuzak. */
    var sezon = LS.get('ag:sezonPlani', undefined);
    if (sezon !== undefined) payload.sezon_plani = sezon;
    if (!Object.keys(payload).length) return null;
    payload.updated_at = new Date().toISOString();
    return payload;
  }

  /* Faz 4B (Cowork gozden gecirme): "Plani sil" LS'e "null" yazar, payload
     sezon_plani: null gider, Worker metafield'i siler. Basarili yanit
     geldiginde bu "null" isaretini LS'ten tamamen KALDIRIYORUZ - aksi
     halde sonraki her senkron (olcu, favori, moment...) gereksiz yere
     ayni metafieldsDelete'i tekrar tetiklerdi. Anahtar yok => payload'da
     alan yok => Worker dokunmaz (uc-durum semantigi korunuyor).
     Koruma: istek ucustayken kullanici yeniden planladiysa LS'te artik
     bir obje vardir - o durumda DOKUNMUYORUZ, yeni plan silinmesin. */
  function clearDeletedFields(payload) {
    if (payload.sezon_plani === null && LS.get('ag:sezonPlani', undefined) === null) {
      try { localStorage.removeItem('ag:sezonPlani'); } catch (e) {}
    }
  }

  function sendSync(isRetry) {
    var payload = buildSyncPayload();
    if (!payload) return;
    fetch(SYNC_ENDPOINT_SAVE, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok) {
        suppressSync = true;
        LS.set('ag:stilUpdatedAt', payload.updated_at);
        suppressSync = false;
        clearDeletedFields(payload);
      } else if (!isRetry) {
        setTimeout(function () { sendSync(true); }, 3000);
      }
    }).catch(function () {
      if (!isRetry) setTimeout(function () { sendSync(true); }, 3000);
    });
  }

  function scheduleSync() {
    if (!loggedIn) return;
    clearTimeout(syncTimer);
    syncPending = true;
    syncTimer = setTimeout(function () { syncPending = false; sendSync(false); }, 2000);
  }

  /* Denetim (3 Eylul, gercek kullanici testinde bulunan hata): quiz
     tamamlaninca ag-wardrobe.js hemen window.location.reload() cagiriyordu -
     scheduleSync'in 2000ms debounce'u bu sureyi neredeyse hicbir zaman
     yakalayamiyordu, sayfa daha timer dolmadan yenileniyordu ve /save'e
     istek HIC gitmiyordu (network sekmesinde sifir kayit, tam olarak
     raporlanan davranis). flushSync bu tur "hemen ardindan sayfa
     degisecek" durumlar icin: debounce'u atlar, isteği ANINDA yollar,
     sonucu (basarili/basarisiz/1.5sn guvenlik zaman asimi) bekleyip
     callback'i cagirir - boylece cagiran taraf (orn. reload) sync
     gercekten bitene KADAR erteleyebilir. */
  function flushSync(callback) {
    clearTimeout(syncTimer);
    syncPending = false;
    if (!loggedIn) {
      // Denetim: misafir /save'e HIC istek atmamali (guest_not_allowed
      // zaten sunucu tarafinda da reddediliyor ama client bunu hic
      // denememeli - scheduleSync'teki ayni kural burada da gecerli).
      if (callback) callback();
      return;
    }
    var payload = buildSyncPayload();
    if (!payload) {
      if (callback) callback();
      return;
    }
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      if (callback) callback();
    };
    fetch(SYNC_ENDPOINT_SAVE, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok) {
        suppressSync = true;
        LS.set('ag:stilUpdatedAt', payload.updated_at);
        suppressSync = false;
        clearDeletedFields(payload);
      }
      finish();
    }).catch(finish);
    setTimeout(finish, 1500);
  }

  function toggleFavorite(handle) {
    var favs = LS.get('ag:favorites', []);
    var idx = favs.indexOf(handle);
    var active;
    if (idx === -1) {
      favs.push(handle);
      active = true;
    } else {
      favs.splice(idx, 1);
      active = false;
    }
    LS.set('ag:favorites', favs);
    return active;
  }

  function isFavorited(handle) {
    return LS.get('ag:favorites', []).indexOf(handle) !== -1;
  }

  /* Sunucudan gelen veriyi localStorage'a yazarken kullanilir (bkz.
     ag-wardrobe.js reconcileWithServer) - LS.set'ten farki, bu yazim
     kendisi bir kullanici eylemi olmadigi icin tekrar sunucuya senkron
     TETIKLEMEMESI gerekiyor (aksi halde sunucudan okunan veri hemen
     sunucuya geri yazilir, gereksiz bir dongu olustururdu). */
  function setSilent(k, v) {
    try {
      localStorage.setItem(k, JSON.stringify(v));
    } catch (e) {}
  }

  /* Kalp butonlarina tikla-degistir - sayfada nerede olursa olsun calisir
     (urun karti, urun sayfasi). SSR zaten dogru baslangic durumunu
     (.ag-fav-btn--active, customer.metafields.stil.favoriler icinde handle
     var mi kontrolu Liquid tarafinda) render ediyor - JS sadece tiklamadan
     SONRAKI degisikligi uyguluyor, sayfa yenilenmeden. Misafir de
     favorileyebilir (quiz'deki gibi) - localStorage'a yazilir, sadece
     giris yapilmissa sunucuya gonderilir (LS.set icindeki loggedIn kontrolu).
  */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ag-fav-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-ag-fav-toggle');
    if (!handle) return;
    var active = toggleFavorite(handle);
    btn.classList.toggle('ag-fav-btn--active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  /* Denetim: SSR (Liquid, customer.metafields.stil.favoriler) sadece giris
     yapmis musteride dogru baslangic durumunu basiyor - misafir icin
     customer nesnesi hic yok, bu yuzden misafirin bir onceki sayfada
     favoriledigi urun, farkli bir sayfaya (orn. urun sayfasina) gecince
     kalp GORSEL olarak sifirlanmis gibi durur (veri localStorage'da guvende
     kalmaya devam eder, sadece ikon yanlis gosterir). Sayfa yuklenince
     mevcut tum kalp butonlarini localStorage'daki favoriler listesiyle
     karsilastirip gerekeni isaretliyoruz - SSR zaten aktifse dokunmuyor
     (sadece EKLIYOR, hicbir aktif durumu geri almiyoruz). */
  function paintFavoriteButtons() {
    var favs = LS.get('ag:favorites', []);
    if (!favs.length) return;
    var buttons = document.querySelectorAll('[data-ag-fav-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var handle = btn.getAttribute('data-ag-fav-toggle');
      if (handle && favs.indexOf(handle) !== -1) {
        btn.classList.add('ag-fav-btn--active');
        btn.setAttribute('aria-pressed', 'true');
      }
    }
  }
  paintFavoriteButtons();

  /* Denetim (3 Eylul): flushSync sadece BIZIM tetikledigimiz (orn. quiz
     "Tamam") reload'lari kapsiyor - kullanici sekmeyi kapatirsa ya da
     baska bir linke tiklarsa bekleyen debounce (scheduleSync) yine
     yakalanamaz. pagehide'da sendBeacon ile son bir deneme yapiyoruz -
     sendBeacon sayfa kapanirken bile tarayicinin garanti ettigi tek
     yontem (normal fetch bu noktada iptal edilebilir). Ayni payload'i
     iki kez gondermek zararsiz (Worker tam-anlik-durum yaziyor, ekleme
     degil), bu yuzden scheduleSync'in de calisiyor olmasi sorun degil. */
  /* Tur 9 T9-009: pagehide olayi window'a gelir, document'e yayilmaz - dinleyici document'teyken bu
     guvenlik agi HIC calismiyordu (degisiklikten sonra 2 sn dolmadan gezinilirse kayit gitmiyordu).
     Yalniz debounce'ta BEKLEYEN bir degisiklik varken gonderilir; aksi halde her sayfa cikisinda tam
     durum yazilir ve baska cihazdaki daha yeni veri eskisiyle ezilebilirdi. */
  window.addEventListener('pagehide', function () {
    if (!loggedIn || !syncPending || typeof navigator.sendBeacon !== 'function') return;
    clearTimeout(syncTimer);
    syncPending = false;
    var payload = buildSyncPayload();
    if (!payload) return;
    try {
      var blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon(SYNC_ENDPOINT_SAVE, blob);
    } catch (e) {}
  });

  window.AGStilSync = {
    LS: LS,
    setSilent: setSilent,
    scheduleSync: scheduleSync,
    flushSync: flushSync,
    buildSyncPayload: buildSyncPayload,
    isLoggedIn: function () { return loggedIn; },
    toggleFavorite: toggleFavorite,
    isFavorited: isFavorited
  };
})();